import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import debounce from "lodash/debounce";
import filter from "lodash/filter";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";

Vue.prototype._ = { cloneDeep, merge, debounce, filter, uniq, uniqBy };
